(function () {
'use strict';

angular.module('hyresgastApp').controller('ListNegotiationCallNewCtrl', ListNegotiationCallNewCtrl);

function ListNegotiationCallNewCtrl(
  $location, $filter,
  Office,
  NegotiationCallStates, NegotiationTypes,
  NegotiationCall
) {
  var vm = this;

  vm.pageLimit = 30;

  let newStates = {
    WAITING_HGF: NegotiationCallStates.WAITING_HGF,
    PARTIALLY_ASSIGNED: NegotiationCallStates.PARTIALLY_ASSIGNED
  };

  Office.query().$promise.then(response => {
    vm.allOffices = response;
    setupTableau();
  });

  let setupTableau = () => {
    vm.statusChoices = Object.values(newStates).map(x => ({
      id: x,
      text: $filter('hyNegotiationCallStates')(x)
    }));
    vm.typeChoices = Object.values(NegotiationTypes).map(x => ({
      id: x,
      text: $filter('hyNegotiationTypes')(x)
    }));
    vm.tableColumns = [
      {
        title: 'Id',
        column: 'caseNumber'
      },
      {
        title: 'Namn',
        column: 'name'
      },
      {
        title: 'Förhandlingstyp',
        template: 'slot1',
        column: 'type',
        lookup: {
          idProperty: 'id',
          textProperty: 'text',
          dictionary: vm.typeChoices,
          multi: true,
        },
      },
      {
        title: 'Skickad till kontor',
        column: 'office.id',
        template: 'slot2',
        lookup: {
          idProperty: 'id',
          textProperty: 'name',
          dictionary: vm.allOffices,
          multi: true,
        },
      },
      {
        title: 'Organisation',
        column: 'counterpart.name'
      },
      {
        title: 'Status',
        template: 'status',
        column: 'state',
        lookup: {
          idProperty: 'id',
          textProperty: 'text',
          dictionary: vm.statusChoices,
          multi: true,
        },
      },
      {
        title: 'Bereds av',
        column: 'handler.fullName',
      },
      {
        title: 'Inskickad',
        column: 'sentAt',
        template: 'slot3',
        filterType: 'none'
      },
    ];
  }

  vm.gotoCall = call => {
    $location.search({});
    $location.path('/negotiation-calls/' + call.id);
  }

  // eslint-disable-next-line no-undef
  vm.tableFGetData = params => new Promise((resolve, reject) => {
    params.mine = true;
    if (!params['filters[state]'] || (params['filters[state]'].length === 0)) {
      params['filters[state]'] = Object.values(newStates);
    }
    NegotiationCall.query(params)
      .$promise.then(response => resolve(response))
      .catch(err => reject(err));
  });
}
})();